import { render, staticRenderFns } from "./Tests.vue?vue&type=template&id=ca46a8c0"
import script from "./Tests.vue?vue&type=script&lang=js"
export * from "./Tests.vue?vue&type=script&lang=js"
import style0 from "./Tests.vue?vue&type=style&index=0&id=ca46a8c0&prod&lang=css"
import style1 from "./Tests.vue?vue&type=style&index=1&id=ca46a8c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports